/* eslint-disable no-new */
export default {
    /**
     * @override
     */
    setTabs({ commit }, tabs) {
        new Promise(resolve => {
            commit('SET_TABS', tabs);
            resolve();
        });
    },
    /**
     * @override
     */
    setNewFloatWindow({ commit }, payload) {
        new Promise(resolve => {
            commit('SET_NEW_FLOAT_WINDOW', payload);
            resolve();
        });
    },    /**
    * @override
    */
    removeFloatWindow({ commit }, payload) {
        new Promise(resolve => {
            commit('REMOVE_FLOAT_WINDOW', payload);
            resolve();
        });
    }
};
